import React from 'react';
import classnames from 'classnames/bind';

import HomeIcon from '@icons/home';
import ShareIcon from '@icons/share';
import css from './menu-toolbar.module.scss';

const styles = classnames.bind(css);

const MenuToolbar = ({ currentSlide, totalSlides, navigate, navigateToHome, navigateToShare }) => {
    const base_toolbar_height = 315;
    const height = totalSlides ? base_toolbar_height + 20 * (totalSlides - 3) : 0;

    return (
        <div className={styles('toolbar')} style={{ height }}>
            <div className={styles('toolbar__inner')}>
                <nav aria-label="Slides" className={styles('toolbar__dots')}>
                    <HomeIcon
                        className={styles('toolbar__home-icon')}
                        onClick={navigateToHome}
                        role="button"
                        aria-label="Navigate to cover slide"
                    />
                    {Array(totalSlides)
                        .fill(0)
                        .map((_, index) => (
                            <div
                                role="button"
                                className={styles('toolbar__dot')}
                                onClick={() => navigate(index)}
                                key={index}
                            >
                                <div
                                    aria-label={`Navigate to slide ${index + 1}`}
                                    className={styles('toolbar__dot-inner', {
                                        'toolbar__dot-inner--active': currentSlide === index,
                                    })}
                                />
                            </div>
                        ))}
                    <ShareIcon
                        className={styles('toolbar__share-icon')}
                        onClick={navigateToShare}
                        role="button"
                        aria-label="Navigate to share slide"
                    />
                </nav>
            </div>
        </div>
    );
};

export default MenuToolbar;
